import { Button, CircularProgress, IconButton, InputAdornment, TextField, Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import moment from 'moment';
import React, { useEffect } from 'react'; 
import { useRef } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { commentPost } from '../../actions/posts';
import theme from '../../muiTheme';
import CustomInput from '../Form/CustomInput';
import UserAvatar from '../UserAvatar/UserAvatar';
import styles from './styles'; 
import {HiPaperAirplane, HiBadgeCheck} from 'react-icons/hi';

const CommentSection = ({post, initialComments, onComment, loading=false, fetchMore=false, onFetchMore, fixedInput = false}) => {

    const [comment, setComment] = useState('');
    const [comments, setComments] = useState([]);
    const dispatch = useDispatch(); 
    const user = JSON.parse(localStorage.getItem('profile'));
    const containerRef = useRef(null); 
    const commentRef = useRef(null);
    const isMobile = useMediaQuery('(max-width: 768px)');

    useEffect(()=>{

        if(initialComments){

            setComments(initialComments);

        }

    }, [initialComments]);

    const handleInputChange = (event) => {

        setComment(event.target.value);
    }

    const submitComment = async (event) => {

        event.preventDefault();

        console.log('post: ', post);

        dispatch(commentPost(comment, post._id, user.result._id, (error, res)=>{

            if(error){

                return console.warn('error posting comment: ', error);
            }

            console.log('comment res: ', res);

            if(res.comment && typeof onComment === 'function'){
                
                onComment(res.comment);
            }
            
        }));

        setComment('');

        //scroll to bottom of comment container
        //containerRef.current.scrollTo({behaviour: 'smooth', top: containerRef.current.scrollHeight+20});

        commentRef.current.scrollIntoView({block: 'end', behavior: 'smooth'}); //works but not in chrome :/

    }


    return (
        <div>
            <div style={styles.outerContainer}>

                <Typography gutterBottom variant='h6'>
                    {comments?.length > 0 ? 'Comments' : ' No comments yet' }
                </Typography>

                <Box sx={styles.innerContainer} ref={containerRef}>

                    

                    {
                        comments.map((comment, index)=>(


                            

                                <Box
                                key={'comment_'+index}
                                >
                                    
                                    <Box
                                        
                                        sx={{
                                            display: 'flex', 
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            justifyContent: 'flex-start',
                                            marginTop: '5px',
                                            //maxWidth: '90%',
                                            borderTop: '1px solid '+theme.palette.faint,
                                            padding: '10px 0px'
                                        }}
                                    >

                                        <UserAvatar 
                                            imageURL={comment.creator.profileImage}
                                            url={`/profile/${comment.creator._id}`}
                                            imageSx={{height: '50px', width: '50px'}}
                                            verified={comment.creator.verified}
                                        />

                                        <Typography
                                            variant='body2'
                                            sx={{
                                                fontSize: '16px', 
                                                fontWeight: '600', 
                                                marginRight: '5px',
                                                marginBottom: '0px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-evenly'
                                            
                                            }}
                                        >
                                                {comment.creator.name} 
                                                
                                                {
                                                    comment.creator.verified &&

                                                    <HiBadgeCheck style={{marginLeft: '5px'}}/>
                                                }
                                                
                                        </Typography>

                                        <Typography
                                            sx={{marginTop: '0px'}}
                                        >
                                                {comment.body}
                                        </Typography>
        
                                    </Box>

                                    <Typography
                                        variant='subtitle1'
                                        sx={{fontSize: '12px', fontStyle: 'italic', color: theme.palette.lightGray}}
                                    >
                                        {moment(comment.createdAt).fromNow()}
                                    </Typography>

                                </Box>
                                

                                
                            
                        ))
                    }

                    {
                        fetchMore && 

                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: '20px'
                            }}
                        >


                            {
                                loading ? 


                                <CircularProgress />

                                :

                                <Button 


                                    variant='main'
                                    onClick={()=>{
                                        if(typeof onFetchMore === 'function'){

                                            onFetchMore();
                                        }
                                    }}
                                    >

                                    See more comments
                                </Button>
                            }
                            
                        </Box>
                        
                    }

                    <div ref={commentRef}></div>

                </Box>

                {user?.result.name && 
                
                    <Box
                        sx={{
                            maxWidth: isMobile? '90%' : 'auto',
                            position: fixedInput ? 'sticky' : 'static',
                            bottom: fixedInput ? '-1px' : 'auto',
                            background: fixedInput ? 'white' : 'transparent',
                            width: '100%'
                        }}
                    >

                        {/* <Typography gutterBottom variant='h6'>
                            Write a comment
                        </Typography> */}

                        <CustomInput
                            fullWidth
                            rows={4}
                            variant='outlined'
                            label={comments?.length > 0 ? 'Comment' : ' Be the first to comment!' }
                            multiline
                            value={comment}
                            onChange={handleInputChange}
                            endAdornment={{
                                endAdornment: (
                                    <InputAdornment position='end'>

                                        <IconButton
                                            color='primary'
                                            disabled={!comment}
                                            onClick={submitComment}
                                        >

                                            <HiPaperAirplane style={{
                                                transform: 'rotate(90deg)'
                                            }} />
                                            
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        
                    </Box>
                }
                
            </div>
        </div>
    ); 
}

export default CommentSection; 